import React, { useEffect } from 'react';
import styled from 'styled-components';
import { StatsType } from '../config/stats';
import { headerConfig } from '../utils/baseHeadersConfig';
import { generateTableParams } from '../utils/generateTableParams';
import { MatchesService } from '../utils/MatchesService';
import { addPercentLabelToMatchItemFields } from '../utils/tableTransform';
import { PageTitle } from './PageTitle';
import { TableWithFilters } from './Table/TableWithFilters';
import { useSession } from 'next-auth/react';
import { Seo } from './Seo';
import { PageWithTitle } from './PageWithoutTitle';
import { useAppContext } from '../hooks/useAppContext';
import { IStatPassConditionContext } from '../context/app';
import { useStatChangeContext } from '../hooks/useStatChangeContext';
import { StatsChangeContextProps } from '../context/statsChange';
import { isStatPassCondition } from '../utils/stats';
import { TableItemModal } from './Table/TableItemModal';
// import { usePageTitle } from '../hooks/usePageTitle'

export const StyledScrollContainer = styled.div`
  margin-top: -2.5rem;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-top: -3.5rem;
  }
`;
interface PageStatsProps {
  title: string;
  tooltipText: string;
  statName: StatsType;
  seoTitle: string;
  statsCondition?: IStatPassConditionContext;
  isUnderOver?: boolean;
  allStatsVariants?: StatsChangeContextProps['allStatsVariants'];
}

export const PageStats = ({ title, seoTitle, statName, statsCondition, isUnderOver = false, allStatsVariants = [] }: PageStatsProps) => {
  useSession({
    required: true,
  });
  const { setSelectedStatsCondition } = useAppContext();
  const { setIsUnderOver, setAllStatsVariants } = useStatChangeContext();

  useEffect(() => {
    setSelectedStatsCondition(statsCondition);
    setIsUnderOver(isUnderOver);
    setAllStatsVariants(allStatsVariants);
    return () => {
      setSelectedStatsCondition(null);
      setIsUnderOver(false);
      setAllStatsVariants([]);
    };
  }, []);

  // const { setPageTitle } = usePageTitle()
  // useEffect(() => {
  //   setPageTitle(title)
  // }, [])

  const params = generateTableParams(statName);
  return (
    <StyledScrollContainer>
      <Seo title={seoTitle} />
      <PageWithTitle title={title} />
      {/* <PageTitle
        title={title}
        tooltipText={tooltipText}
      /> */}
      <TableWithFilters
        headerConfig={headerConfig}
        apiMethod={MatchesService.getSpecificStat}
        transformCB={addPercentLabelToMatchItemFields}
        apiMethodParams={params}
        tableType="card"
        calculateStatsStatus={(match) => {
          if (!match.finished) return 'none';
          if (!match.finished.stats.hasStats) return 'none';
          if (!statsCondition) return 'none';

          const isStatsPass = isStatPassCondition({ matchStats: match.finished.stats, statsCondition, statName: params.statName });
          return isStatsPass ? 'pass' : 'fail';
        }}
        renderTableModalItem={(data) => {
          return <TableItemModal open={data.open} match={data.match} handleClose={data.handleClose} date={data.date} statName={data.statName} />;
        }}
      />
    </StyledScrollContainer>
  );
};
